import GeneralForm from "components/GeneralForm"
import { validate } from "components/validateGeneralForm"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import { Button, Modal, ModalBody } from "reactstrap"
import comboService from "services/ComboService"
import ordemServicoService from "services/OrdemServicoService"
import { erroInesperado } from "services/Utils"

export function ModalCriarOrdemServico({ cruzamento, onClosed }) {
  const [data, setData] = useState({})
  const [tiposProblema, setTiposProblema] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    setData({})
  }, [cruzamento])

  useEffect(() => {
    comboService.tipoProblema().then(res => {
      if (res.success) {
        setTiposProblema(res.data)
      }
    })
  }, [])

  const formConfig = [
    [
      {
        name: "idTipoProblema",
        label: 'Descrição do Problema',
        type: "combo",
        required: true,
        colspan: 12,
        options: tiposProblema,
        optionValue: 'id',
        optionLabel: 'descricao',
        showDefault: true,
      },
    ]
  ]

  const handleChange = (name, value) => {
    setData({ ...data, [name]: value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    const errors = validate(formConfig, data)
    if (errors.length > 0) {
      setData({ ...data, errors })
      return
    }

    try {
      const res = await ordemServicoService.create({
        idCruzamento: cruzamento.id,
        idTipoProblema: data.idTipoProblema,
      })
      if (res.success) {
        toast('Registro salvo com sucesso!')
        navigate(`/admin/ordens_servico/${res.data.idOrdemServico}`)
        onClosed && onClosed()
      } else {
        toast('Erro ao criar a Ordem de Serviço')
      }
    } catch (ex) {
      erroInesperado()
    }

  }
  return (
    <Modal
      isOpen={!!cruzamento}
      toggle={onClosed}
      onClosed={onClosed}
    >
      <ModalBody className="d-flex flex-column" style={{ rowGap: 10 }}>
        <h1>Informações do Cruzamento</h1>
        {cruzamento && (
          <>
            <div><strong>Cruzamento:</strong> {cruzamento.numero}</div>
            <div><strong>Endereço:</strong> {cruzamento.endereco}</div>

            <form onSubmit={handleSubmit}>
              <GeneralForm
                config={formConfig}
                data={data}
                onChange={handleChange}
                disabled={false}
              />
              <Button type="submit" color="primary">Criar Ordem de Serviço</Button>
            </form>

          </>
        )}
      </ModalBody>
    </Modal>
  )
}